const VALID_IMAGE_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'];
const VALID_IMAGE_FILE_TYPES_TENANT_LOGO = ['image/svg+xml'];

export const getFileSizeInMB = (bytes: number): string => (bytes / (1024 * 1024)).toFixed(2);

export const isFileSizeValid = (bytes: number, maxSizeMB: number): boolean => {
    const maxBytes = maxSizeMB * 1024 * 1024;

    return bytes <= maxBytes;
};

export const isFileTypeValidImage = (fileType: string): boolean => VALID_IMAGE_FILE_TYPES.includes(fileType);

export const isFileTypeValidTenantLogo = (fileType: string): boolean =>
    [...VALID_IMAGE_FILE_TYPES_TENANT_LOGO, ...VALID_IMAGE_FILE_TYPES].includes(fileType);

const CSV_MIME_TYPES = ['text/csv', 'application/vnd.ms-excel', ''];

export const isCsvFile = (file: File) => {
    const isExtensionValid = file.name.toLowerCase().endsWith('.csv');
    const isTypeValid = CSV_MIME_TYPES.includes(file.type);

    return isExtensionValid && isTypeValid;
};
